import is_today from 'date-fns/is_today';
import is_yesterday from 'date-fns/is_yesterday';
import { CORNER_MARK_PRIORITY, DURATION_PRIORITY, EP_UPDATE_PRIORITY } from './Strategy';
/**
 * @description 播放记录数据
 */
export default class WatchRecord {
    constructor(data, type = 1) {
        if (type === 1) {
            this.record = data.msg;
            this.unionDatas = data.unionDatas;
            this.poster = data.poster;
        }
        else {
            const local = data;
            const [cid, vid] = local.keyid.split('_');
            this.record = {
                recordId: local.keyid,
                cid,
                vid,
                videoTime: Number(local.time),
                viewDate: local.date * 1000,
                playFrom: 2,
            };
        }
        this.initHistoryType();
    }
    get duration() {
        return Number(this.getValueByPriority(DURATION_PRIORITY));
    }
    get epUpdate() {
        return this.getValueByPriority(EP_UPDATE_PRIORITY);
    }
    get cornerMarkSrc() {
        return this.getValueByPriority(CORNER_MARK_PRIORITY);
    }
    get timeDur() {
        let time = Number(this.record.videoTime);
        if (time < 0) {
            time = 0;
        }
        return Number((Number(time / this.duration).toFixed(2) * 100).toFixed(0));
    }
    getUnionValue(unionId, key) {
        try {
            const unionData = this.unionDatas.find(item => item.tableId === unionId);
            return unionData.fields[key] || '';
        }
        catch (error) {
            return '';
        }
    }
    getValueByPriority(strategy) {
        let val = '';
        strategy.some((item) => {
            val = this.getUnionValue(item[0], item[1]);
            if (val)
                return true;
        });
        return val;
    }
    initHistoryType() {
        const date = Number(this.record.viewDate) * 1000;
        if (is_today(date)) {
            this.historyType = 'today';
        }
        else if (is_yesterday(date)) {
            this.historyType = 'yesterday';
        }
        else {
            this.historyType = 'earlier';
        }
    }
}
